import RemindersCalendar from './RemindersCalendar';

export default RemindersCalendar;
